import React from "react";
import {DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";

const CandidateProposalActions = ({
                                      positionAssignable,
                                      candidate,
                                      assigned,
                                      isDisabled,
                                      onUnassignCandidate,
                                      onAddCandidate,
                                      onRemoveCandidate,
                                      onAssignCandidate,
                                      canAssignTalentForProject,
                                      canInvite
                                  }) => {



    return (
        <div className="candidate-proposal-actions">

            {candidate.job_candidate.is_assigned ? (
                <div className="candidate-actions-container">
                    <h4>Accepted Rate</h4>
                    <h2>
                        <sup>$</sup>
                        <span>
                            <span>
                                {candidate.proposedPlatformRate(false)}/hr
                            </span>
                        </span>
                    </h2>
                </div>
            ) : (
                <React.Fragment>
                    {candidate.changedHourlyRate() && (
                        <div className="candidate-actions-container rate-change">
                            <h4>{candidate.client_override_hourly_rate ? "Preferred Rate": "Standard Rate"}</h4>
                            <h2>
                                <sup>$</sup>
                                <span>
                                    <span>
                                        {candidate.standardPlatformRate(false)}/hr
                                    </span>
                                </span>
                            </h2>
                        </div>
                    )}

                    <div className="candidate-actions-container">

                        <h4>
                            {candidate.changedHourlyRate() ? 'Proposed Rate' :
                                (candidate.client_override_hourly_rate ? "Preferred Rate": "Standard Rate")}
                        </h4>
                        <h2>
                            <sup>$</sup>
                            {candidate.changedHourlyRate() ?
                                candidate.proposedPlatformRate(false) :
                                candidate.standardPlatformRate(false)
                            }/hr
                        </h2>
                    </div>
                </React.Fragment>
            )}

            {candidate.job_candidate.is_shortlisted ? (
                <React.Fragment>
                    {candidate.isPendingShortlisted() && (
                        <div className="btn btn-outline-dark no-click invited-candidate-actions shortlisted-actions pending">
                            <i className="fas fa-question-circle"/>
                            <p>
                                Waiting for proposal
                            </p>
                        </div>
                    )}

                    {candidate.declinedPosition() && (
                        <div className="btn btn-outline-dark no-click invited-candidate-actions shortlisted-actions declined">
                            <i className="fas fa-times-circle"/>
                            <p>
                                Declined Project
                            </p>
                        </div>
                    )}

                    {candidate.shortlistedAccepted() && candidate.job_candidate.is_assigned && (
                        <button
                            type="button"
                            className="btn btn-block btn-success no-click"
                            onClick={(e) => e.preventDefault()}>
                            Selected
                        </button>
                    )}

                    {candidate.shortlistedAccepted() && !candidate.job_candidate.is_assigned && positionAssignable && (
                        <button
                            type="button"
                            className={TB.mapClass('btn btn-block btn-outline-dark btn-primary', {
                                'disabled-edit-link': !canAssignTalentForProject
                            })}
                            disabled={isDisabled || assigned}
                            onClick={() => {
                                if (!canAssignTalentForProject) {
                                    return TB.showPermissionError();
                                }
                                return onAssignCandidate(candidate)
                            }}>
                            Select
                            {!canAssignTalentForProject && (
                                <i className="fa fa-lock ml-1"/>
                            )}
                        </button>
                    )}

                    {(positionAssignable || !candidate.job_candidate.is_assigned) && (
                        <UncontrolledDropdown direction="down">
                            <DropdownToggle
                                tag="button"
                                className="clickable btn btn-outline-dark" style={{pointerEvents: 'all'}} onClick={e => {
                                e.stopPropagation()
                            }}>
                                <i className="fas fa-ellipsis-v"></i>
                            </DropdownToggle>
                            <DropdownMenu container="body">

                                {candidate.is_assigned ? (
                                    <DropdownItem
                                        disabled={isDisabled || !canAssignTalentForProject}
                                        onClick={() => {
                                            if (!canAssignTalentForProject) {
                                                return TB.showPermissionError();
                                            }
                                            return onUnassignCandidate(candidate)
                                        }}
                                    >
                                        Reopen Position
                                        {!canAssignTalentForProject && (
                                            <i className="fa fa-lock ml-1"/>
                                        )}
                                    </DropdownItem>
                                ) : (
                                    <DropdownItem
                                        disabled={isDisabled || !canInvite}
                                        onClick={() => {
                                            if (!canInvite) {
                                                return TB.showPermissionError();
                                            }
                                            return onRemoveCandidate(candidate);
                                        }}
                                    >
                                        {candidate.isShortlisted() ? 'Remove from Shortlist' : (
                                            candidate.isPendingShortlisted() ? 'Cancel Invite' : (
                                                candidate.declinedPosition() && 'Remove from Shortlist'
                                            )
                                        )}

                                        {!canInvite && (
                                            <i className="fa fa-lock ml-1"/>
                                        )}
                                    </DropdownItem>
                                )}

                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}
                </React.Fragment>
            ) : (
                <button
                    type="button"
                    disabled={isDisabled || candidate.job_candidate.is_archived || candidate.disabledFromInvite()}
                    className={TB.mapClass('btn btn-primary btn-block project-invite-btn', {
                        'disabled-edit-link': !canInvite || assigned
                    })}
                    onClick={() => {
                        if (!canInvite) {
                            return TB.showPermissionError();
                        }
                        if (assigned) {
                            return TB.toast("Position has already been filled!", {theme: 'danger'})
                        }
                        return onAddCandidate()
                    }}
                >
                    {candidate.matchStatusIsInterested() ? (
                        <React.Fragment>
                            Add to Shortlist

                            {!canInvite && (
                                <i className="fa fa-lock ml-1"/>
                            )}
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            Invite To Propose
                            {!canInvite && (
                                <i className="fa fa-lock ml-1"/>
                            )}
                        </React.Fragment>
                    )}
                </button>
            )}


        </div>
    )
}
export default CandidateProposalActions;